module.exports = {
	"description": "The Button component represents a clickable button.\nButtons draw attention to actions that can be performed in your app.\nButtons are used to trigger any sort of event.\n\nButtons with clear messaging and an appropriate variant applied communicate intention effectively.",
	"methods": [],
	"props": {
		"children": {
			"flowType": {
				"name": "React$Node"
			},
			"required": false,
			"description": "Rendered content of the component"
		},
		"circular": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Displays a circular Button"
		},
		"disabled": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Disables the Button"
		},
		"fullWidth": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Stretch Button to fill its container"
		},
		"iconEnd": {
			"flowType": {
				"name": "React$Element",
				"elements": [
					{
						"name": "unknown"
					}
				],
				"raw": "React$Element<*>"
			},
			"required": false,
			"description": "Icon that goes after the children"
		},
		"iconStart": {
			"flowType": {
				"name": "React$Element",
				"elements": [
					{
						"name": "unknown"
					}
				],
				"raw": "React$Element<*>"
			},
			"required": false,
			"description": "Icon that goes before the children"
		},
		"minimal": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Display a minimal Button"
		},
		"onClick": {
			"flowType": {
				"name": "signature",
				"type": "function",
				"raw": "(event: SyntheticEvent<>) => void",
				"signature": {
					"arguments": [
						{
							"name": "event",
							"type": {
								"name": "SyntheticEvent",
								"elements": [],
								"raw": "SyntheticEvent<>"
							}
						}
					],
					"return": {
						"name": "void"
					}
				}
			},
			"required": false,
			"description": "Called with the click event"
		},
		"primary": {
			"flowType": {
				"name": "boolean"
			},
			"required": false,
			"description": "Display a primary Button"
		},
		"size": {
			"flowType": {
				"name": "union",
				"raw": "'small' | 'medium' | 'large' | 'jumbo'",
				"elements": [
					{
						"name": "literal",
						"value": "'small'"
					},
					{
						"name": "literal",
						"value": "'medium'"
					},
					{
						"name": "literal",
						"value": "'large'"
					},
					{
						"name": "literal",
						"value": "'jumbo'"
					}
				]
			},
			"required": false,
			"description": "Available sizes",
			"defaultValue": {
				"value": "'large'",
				"computed": false
			}
		},
		"type": {
			"flowType": {
				"name": "union",
				"raw": "'button' | 'submit'",
				"elements": [
					{
						"name": "literal",
						"value": "'button'"
					},
					{
						"name": "literal",
						"value": "'submit'"
					}
				]
			},
			"required": false,
			"description": "Available types",
			"defaultValue": {
				"value": "'button'",
				"computed": false
			}
		},
		"variant": {
			"flowType": {
				"name": "union",
				"raw": "'regular' | 'danger' | 'success' | 'warning'",
				"elements": [
					{
						"name": "literal",
						"value": "'regular'"
					},
					{
						"name": "literal",
						"value": "'danger'"
					},
					{
						"name": "literal",
						"value": "'success'"
					},
					{
						"name": "literal",
						"value": "'warning'"
					}
				]
			},
			"required": false,
			"description": "Available variants",
			"defaultValue": {
				"value": "'regular'",
				"computed": false
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-docgen-loader!./src/Button/Button.js
// module id = 1583
// module chunks = 0